import { useEffect, useState } from 'react'
import { useNotify, useRecordContext, useRefresh } from 'react-admin'
import { Button } from '@mui/material'
import {
  completeSalvageBooking,
  sendJobToCL,
} from '../../../../../Utils/RestUtils'
import { AgentAssignValidator } from '../../ViewAgentsPanel/AgentAssignValidator'
import CancelBookingModal from '../CancelBookingModal'
import PropTypes from 'prop-types'
import {
  BMS_SALVAGE_AGENT_ID,
  SHORE_CARS_AGENT_ID,
} from '../../../../../Utils/ConstantsUtils'

const CompleteBookingButtonSalvage = ({
  termsRead,
  termsConfirmed,
  purchaseAgreementSent,
  assignedTo,
}) => {
  const record = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [canCompleteBooking, setCanCompleteBooking] = useState(false)
  const isBookingCompleted = record.bookingCompleted
  const roles = localStorage.getItem('permissions').split(',')

  useEffect(() => {
    setCanCompleteBooking(
      termsConfirmed === true && purchaseAgreementSent === true
    )
  }, [termsRead, termsConfirmed, purchaseAgreementSent, refresh])

  const handleResendToCL = async () => {
    const response = await sendJobToCL(record.originId)

    if (response.status !== 200) {
      notify(response.data.errors, { type: 'error' })
    } else {
      notify('Successfully sent job to Collector Logic', { type: 'success' })
    }
  }

  const handleCompleteBooking = async () => {
    const agentId =
      assignedTo === 'salvage'
        ? BMS_SALVAGE_AGENT_ID
        : assignedTo === 'cars'
        ? SHORE_CARS_AGENT_ID
        : 0

    if (agentId === 0) {
      notify('Assigned to not selected', { type: 'error' })
      return
    }

    const errors = await AgentAssignValidator(record, agentId)
    if (errors === false) {
      //Means that it is under outstanding finance and agent didn't want to proceed
      return
    }

    if (errors.length > 0) {
      notify(
        'Please fix below issues in order to assign an agent: \n\n' +
          errors.join(';\n'),
        { type: 'error', multiLine: true }
      )
      return
    }

    const bookingResponse = await completeSalvageBooking({
      quoteRequestId: record['@id'],
    })

    if (bookingResponse.result === 'success') {
      refresh()
      notify('Booking successfully assigned', { type: 'success' })
    } else {
      notify(bookingResponse.error_msg, { type: 'error' })
    }
  }

  return !isBookingCompleted ? (
    <Button
      variant="contained"
      disabled={!canCompleteBooking && !isBookingCompleted}
      fullWidth
      onClick={handleCompleteBooking}
    >
      Assign & Complete Booking
    </Button>
  ) : (
    <>
      {record.status === 'Collected' &&
        record.leadContact.vehicle.vehicleSalvage.assignedTo === 'cars' &&
        (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) && (
          <Button variant="contained" fullWidth onClick={handleResendToCL}>
            Resend to collector logic
          </Button>
        )}
      <CancelBookingModal />
    </>
  )
}

export default CompleteBookingButtonSalvage

CompleteBookingButtonSalvage.propTypes = {
  termsRead: PropTypes.bool,
  termsConfirmed: PropTypes.bool,
  purchaseAgreementSent: PropTypes.bool,
  assignedTo: PropTypes.any,
}
